import { SunIcon, MoonIcon } from '@/components/icons';

interface ThemeToggleProps {
  isDark: boolean;
  onToggle: () => void;
}

/**
 * ThemeToggle Component
 *
 * Animated toggle button for switching between light and dark themes.
 * Displays sun icon for light mode, moon icon for dark mode.
 */
export function ThemeToggle({ isDark, onToggle }: ThemeToggleProps) {
  return (
    <button
      onClick={onToggle}
      className="theme-toggle"
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <SunIcon size={24} className="theme-toggle__icon" />
      ) : (
        <MoonIcon size={24} className="theme-toggle__icon" />
      )}
    </button>
  );
}
